const state = {
	items: [],
	paging: {},
	item: {}
}
const mutations = {
	SET_FAILED_LEAD_ITEMS: (state, payload) => {
		state.items = payload.data;
		const pages = Object.assign(payload.pages, payload.items);
		state.paging = Object.assign({}, pages);
	},
	SET_FAILED_LEAD_ITEM: (state, payload) => {
		state.item = Object.assign({}, payload);
	}
}

const actions = {
	setFailedLeadItems({ commit }, payload) {
		commit('SET_FAILED_LEAD_ITEMS', payload)
	},
	setFailedLeadItem({ commit }, payload) {
		commit('SET_FAILED_LEAD_ITEM', payload);
	},
}

const getters = {
	failedLeadItems: state => state.items,
	failedLeadPaging: state => state.paging,
	failedLeadItem: state => state.item
}

export default {
	state,
	mutations,
	actions,
	getters
}


// WEBPACK FOOTER //
// ./src/store/module/failedLeads.js